























import { Component, Vue, Prop } from "vue-property-decorator";
import Rules from "@/code/ValidationRules";
import { ValidationFunctionType } from "@/code/ValidationRules";

@Component
export default class TextField extends Vue {
  @Prop(String)
  value!: string;

  @Prop(String)
  label!: string;

  @Prop(String)
  help: string | undefined;

  @Prop(String)
  type: string | undefined;

  @Prop()
  rules: ValidationFunctionType[] | undefined;

  @Prop(Boolean)
  disabled: boolean | undefined;

  validationRules = Rules;
}
